<template>
  <div class>
    <div class="container-fluid">
      <div class="custom-container">
        <div class="menu-setup-wrap-section mt-4 pb-8">
          <template>
            <div class="menu-setup-tab-wrap">
              <v-tabs v-model="tab" lign-with-title>
                <v-tabs-slider color="#1c1d26"></v-tabs-slider>
                <v-tab active-class="tab-active"> Web Menu </v-tab>
                <v-tab active-class="tab-active"> App Menu </v-tab>
              </v-tabs>
            </div>
          </template>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <!-- Webmenu Modal -->
              <div class="webmenu-modal webmenu mt-5">
                <div class="managemenu-head">
                  <div>
                    <p>
                      Drag available menus from left and drop to right for
                      navigation menu.
                    </p>
                  </div>
                </div>
                <v-row>
                  <v-col md="4" sm="4" cols="12" class="mt-5">
                    <div class="available-menu-head">
                      <p class="mt-0">Available menus</p>
                    </div>
                    <div class="menu-list static-menu">
                      <ul>
                        <draggable
                          :list="ClientMenu"
                          :move="checkMoveSelectedWeb"
                          :group="{ name: 'tags', pull: 'clone', put: false }"
                          :clone="cloneOriginal"
                        >
                          <li
                            v-for="menu in ClientMenu"
                            :key="'WebClientMenu_' + menu.MenuID"
                            :id="'WebClientMenu__' + menu.MenuID"
                          >
                            <div class="single-drag-menu">
                              <img :src="menu.IconUrl" height="20" width="20" />
                              <p>{{ DisplayLanguageLabel(menu) }}</p>
                            </div>
                          </li>
                        </draggable>
                      </ul>
                    </div>
                  </v-col>
                  <v-col md="4" sm="4" cols="12" class="mt-5">
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        available-menu-head
                        position-relative
                      "
                    >
                      <p class="mt-0">Top Menu</p>
                      <div>
                        <v-icon color="#333" size="20px" class="ml-3 info-ico"
                          >mdi-information-outline</v-icon
                        >
                        <div class="common-menu-tooltip">
                          <img src="../assets/Images/web-top-menu.jpg" />
                        </div>
                      </div>
                    </div>
                    <div class="menu-list border-menu">
                      <ul>
                        <draggable
                          id="WebTopMenu"
                          class="menu-dragbox"
                          :list="WebTopMenu"
                          :group="{ name: 'tags' }"
                        >
                          <li
                            v-for="menu in WebTopMenu"
                            :key="'WebTopMenu_' + menu.MenuID"
                          >
                            <div
                              class="
                                single-drag-menu
                                editable
                                justify-content-between
                                align-items-center
                              "
                            >
                              <div
                                class="
                                  d-flex
                                  justify-content-start
                                  align-items-center
                                "
                              >
                                <img
                                  :src="menu.IconUrl"
                                  height="20"
                                  width="20"
                                />
                                <p
                                  v-if="
                                    currentEditMenuId !=
                                    'WebTopMenu_' + menu.MenuID
                                  "
                                  class="
                                    d-flex
                                    justify-content-start
                                    align-items-center
                                    text-nowrap
                                  "
                                  @dblclick="
                                    onEditMenuClick('WebTopMenu_' + menu.MenuID)
                                  "
                                >
                                  {{ DisplayLanguageLabel(menu) }}
                                </p>
                                <input
                                  v-if="
                                    currentEditMenuId ==
                                    'WebTopMenu_' + menu.MenuID
                                  "
                                  type="text"
                                  :id="'Input_WebTopMenu_' + menu.MenuID"
                                  v-model="menu[menu.ModelDisplayLabel]"
                                  :placeholder="menu.DisplayLabel"
                                  class="menu-input"
                                  @keydown.enter.prevent="onEnterKeyPress"
                                  @blur="currentEditMenuId = ''"
                                />
                              </div>
                              <div
                                v-show="
                                  currentEditMenuId !=
                                  'WebTopMenu_' + menu.MenuID
                                "
                                class="edit-dlt"
                              >
                                <span
                                  @click="
                                    onEditMenuClick('WebTopMenu_' + menu.MenuID)
                                  "
                                  ><v-icon color="#959595" size="20px">
                                    mdi-square-edit-outline</v-icon
                                  ></span
                                >
                                <span
                                  @click="onDeleteMenuClick(menu.MenuID, 1, 1)"
                                  ><v-icon color="#959595" size="20px">
                                    mdi-trash-can-outline</v-icon
                                  ></span
                                >
                              </div>
                            </div>
                          </li>
                        </draggable>
                      </ul>
                    </div>
                  </v-col>
                  <v-col md="4" sm="4" cols="12" class="mt-5">
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        available-menu-head
                        position-relative
                      "
                    >
                      <p class="mt-0">Left Menu</p>
                      <div>
                        <v-icon color="#333" size="20px" class="ml-3 info-ico"
                          >mdi-information-outline</v-icon
                        >
                        <div class="common-menu-tooltip">
                          <img src="../assets/Images/left-menu.jpg" />
                        </div>
                      </div>
                    </div>
                    <div class="menu-list border-menu">
                      <ul>
                        <draggable
                          id="WebLeftMenu"
                          class="menu-dragbox"
                          :list="WebLeftMenu"
                          :group="{ name: 'tags' }"
                        >
                          <li
                            v-for="menu in WebLeftMenu"
                            :key="'WebLeftMenu_' + menu.MenuID"
                          >
                            <div
                              class="
                                single-drag-menu
                                editable
                                justify-content-between
                                align-items-center
                              "
                            >
                              <div
                                class="
                                  d-flex
                                  justify-content-start
                                  align-items-center
                                "
                              >
                                <img
                                  :src="menu.IconUrl"
                                  height="20"
                                  width="20"
                                />
                                <p
                                  v-if="
                                    currentEditMenuId !=
                                    'WebLeftMenu_' + menu.MenuID
                                  "
                                  class="
                                    d-flex
                                    justify-content-start
                                    align-items-center
                                    text-nowrap
                                  "
                                  @dblclick="
                                    onEditMenuClick(
                                      'WebLeftMenu_' + menu.MenuID
                                    )
                                  "
                                >
                                  {{ DisplayLanguageLabel(menu) }}
                                </p>
                                <input
                                  v-if="
                                    currentEditMenuId ==
                                    'WebLeftMenu_' + menu.MenuID
                                  "
                                  type="text"
                                  :id="'Input_WebLeftMenu_' + menu.MenuID"
                                  v-model="menu[menu.ModelDisplayLabel]"
                                  :placeholder="menu.DisplayLabel"
                                  class="menu-input"
                                  @keydown.enter.prevent="onEnterKeyPress"
                                  @blur="currentEditMenuId = ''"
                                />
                              </div>
                              <div
                                v-show="
                                  currentEditMenuId !=
                                  'WebLeftMenu_' + menu.MenuID
                                "
                                class="edit-dlt"
                              >
                                <span
                                  @click="
                                    onEditMenuClick(
                                      'WebLeftMenu_' + menu.MenuID
                                    )
                                  "
                                  ><v-icon color="#959595" size="20px">
                                    mdi-square-edit-outline</v-icon
                                  ></span
                                >
                                <span
                                  @click="onDeleteMenuClick(menu.MenuID, 1, 2)"
                                  ><v-icon color="#959595" size="20px">
                                    mdi-trash-can-outline</v-icon
                                  ></span
                                >
                              </div>
                            </div>
                          </li>
                        </draggable>
                      </ul>
                    </div>
                  </v-col>
                </v-row>
              </div>
              <!-- Webmenu Modal -->
            </v-tab-item>
            <v-tab-item>
              <!-- Mobilemenu Modal -->
              <div class="webmenu-modal appmenu mt-5">
                <div class="managemenu-head">
                  <div>
                    <p>
                      Drag available menus from left and drop to right for
                      navigation menu.
                    </p>
                  </div>
                </div>
                <v-row>
                  <v-col md="3" sm="3" cols="12" class="mt-5">
                    <div class="available-menu-head">
                      <p class="mt-0">Available menus</p>
                    </div>
                    <div class="menu-list static-menu">
                      <ul>
                        <draggable
                          :list="ClientMenu"
                          :move="checkMoveSelectedApp"
                          :group="{ name: 'tags', pull: 'clone', put: false }"
                          :clone="cloneOriginal"
                        >
                          <li
                            v-for="menu in ClientMenu"
                            :key="'AppClientMenu_' + menu.MenuID"
                          >
                            <div class="single-drag-menu">
                              <img :src="menu.IconUrl" height="20" width="20" />
                              <p>{{ DisplayLanguageLabel(menu) }}</p>
                            </div>
                          </li>
                        </draggable>
                      </ul>
                    </div>
                  </v-col>
                  <v-col md="3" sm="3" cols="12" class="mt-5">
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        available-menu-head
                        position-relative
                      "
                    >
                      <p class="mt-0">App Bottom Menu</p>
                      <div>
                        <v-icon color="#333" size="20px" class="ml-3 info-ico"
                          >mdi-information-outline</v-icon
                        >
                        <div
                          class="common-menu-tooltip mobile-tooltip-menu-image"
                        >
                          <img src="../assets/Images/app-bottom-menu.png" />
                        </div>
                      </div>
                    </div>
                    <div class="menu-list border-menu">
                      <ul>
                        <draggable
                          id="AppBottomMenu"
                          class="menu-dragbox"
                          :list="AppBottomMenu"
                          :group="{
                            name: 'tags',
                            put: checkAppLength('bottom'),
                          }"
                        >
                          <li
                            v-for="menu in AppBottomMenu"
                            :key="'AppBottomMenu_' + menu.MenuID"
                          >
                            <div
                              class="
                                single-drag-menu
                                editable
                                justify-content-between
                                align-items-center
                              "
                            >
                              <div
                                class="
                                  d-flex
                                  justify-content-start
                                  align-items-center
                                "
                              >
                                <img
                                  :src="menu.IconUrl"
                                  height="20"
                                  width="20"
                                />
                                <p
                                  v-if="
                                    currentEditMenuId !=
                                    'AppBottomMenu_' + menu.MenuID
                                  "
                                  class="
                                    d-flex
                                    justify-content-start
                                    align-items-center
                                    text-nowrap
                                  "
                                  @dblclick="
                                    onEditMenuClick(
                                      'AppBottomMenu_' + menu.MenuID
                                    )
                                  "
                                >
                                  {{ DisplayLanguageLabel(menu) }}
                                </p>
                                <input
                                  v-show="
                                    currentEditMenuId ==
                                    'AppBottomMenu_' + menu.MenuID
                                  "
                                  type="text"
                                  :id="'Input_AppBottomMenu_' + menu.MenuID"
                                  v-model="menu[menu.ModelDisplayLabel]"
                                  :placeholder="menu.DisplayLabel"
                                  class="menu-input"
                                  @keydown.enter.prevent="onEnterKeyPress"
                                  @blur="currentEditMenuId = ''"
                                />
                              </div>
                              <div
                                v-show="
                                  currentEditMenuId !=
                                  'AppBottomMenu_' + menu.MenuID
                                "
                                class="edit-dlt"
                              >
                                <span
                                  @click="
                                    onEditMenuClick(
                                      'AppBottomMenu_' + menu.MenuID
                                    )
                                  "
                                  ><v-icon color="#959595" size="20px">
                                    mdi-square-edit-outline</v-icon
                                  ></span
                                >
                                <span
                                  @click="onDeleteMenuClick(menu.MenuID, 2, 1)"
                                  ><v-icon color="#959595" size="20px">
                                    mdi-trash-can-outline</v-icon
                                  ></span
                                >
                              </div>
                            </div>
                          </li>
                        </draggable>
                      </ul>
                    </div>
                  </v-col>
                  <v-col md="3" sm="3" cols="12" class="mt-5">
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        available-menu-head
                        position-relative
                      "
                    >
                      <p class="mt-0">App Hamburger Menu</p>
                      <div>
                        <v-icon color="#333" size="20px" class="ml-3 info-ico"
                          >mdi-information-outline</v-icon
                        >
                        <div
                          class="common-menu-tooltip mobile-tooltip-menu-image"
                        >
                          <img src="../assets/Images/app-hamburger-menu.png" />
                        </div>
                      </div>
                    </div>
                    <div class="menu-list border-menu">
                      <ul>
                        <draggable
                          id="AppHamburgerMenu"
                          class="menu-dragbox"
                          :list="AppHamburgerMenu"
                          :group="{ name: 'tags' }"
                        >
                          <li
                            v-for="menu in AppHamburgerMenu"
                            :key="'AppHamburgerMenu_' + menu.MenuID"
                          >
                            <div
                              class="
                                single-drag-menu
                                editable
                                justify-content-between
                                align-items-center
                              "
                            >
                              <div
                                class="
                                  d-flex
                                  justify-content-start
                                  align-items-center
                                "
                              >
                                <img
                                  :src="menu.IconUrl"
                                  height="20"
                                  width="20"
                                />
                                <p
                                  v-if="
                                    currentEditMenuId !=
                                    'AppHamburgerMenu_' + menu.MenuID
                                  "
                                  class="
                                    d-flex
                                    justify-content-start
                                    align-items-center
                                    text-nowrap
                                  "
                                  @dblclick="
                                    onEditMenuClick(
                                      'AppHamburgerMenu_' + menu.MenuID
                                    )
                                  "
                                >
                                  {{ DisplayLanguageLabel(menu) }}
                                </p>
                                <input
                                  v-if="
                                    currentEditMenuId ==
                                    'AppHamburgerMenu_' + menu.MenuID
                                  "
                                  type="text"
                                  :id="'Input_AppHamburgerMenu_' + menu.MenuID"
                                  v-model="menu[menu.ModelDisplayLabel]"
                                  :placeholder="menu.DisplayLabel"
                                  class="menu-input"
                                  v-on:keydown.enter.prevent="onEnterKeyPress"
                                  @blur="currentEditMenuId = ''"
                                />
                              </div>
                              <div
                                v-if="
                                  currentEditMenuId !=
                                  'AppHamburgerMenu_' + menu.MenuID
                                "
                                class="edit-dlt"
                              >
                                <span
                                  @click="
                                    onEditMenuClick(
                                      'AppHamburgerMenu_' + menu.MenuID
                                    )
                                  "
                                  ><v-icon color="#959595" size="20px">
                                    mdi-square-edit-outline</v-icon
                                  ></span
                                >
                                <span
                                  @click="onDeleteMenuClick(menu.MenuID, 2, 2)"
                                  ><v-icon color="#959595" size="20px">
                                    mdi-trash-can-outline</v-icon
                                  ></span
                                >
                              </div>
                            </div>
                          </li>
                        </draggable>
                      </ul>
                    </div>
                  </v-col>

                  <v-col md="3" sm="3" cols="12" class="mt-5">
                    <div
                      class="
                        d-flex
                        justify-content-start
                        align-items-center
                        available-menu-head
                        position-relative
                      "
                    >
                      <p class="mt-0">App Lobby Menu</p>
                      <div>
                        <v-icon color="#333" size="20px" class="ml-3 info-ico"
                          >mdi-information-outline</v-icon
                        >
                        <div
                          class="common-menu-tooltip mobile-tooltip-menu-image"
                        >
                          <img src="../assets/Images/app-lobby-menu.png" />
                        </div>
                      </div>
                    </div>
                    <div class="menu-list border-menu">
                      <ul>
                        <draggable
                          id="AppLobbyMenu"
                          class="menu-dragbox"
                          :list="AppLobbyMenu"
                          :group="{ name: 'tags' }"
                        >
                          <li
                            v-for="menu in AppLobbyMenu"
                            :key="'AppLobbyMenu_' + menu.MenuID"
                          >
                            <div
                              class="
                                single-drag-menu
                                editable
                                justify-content-between
                                align-items-center
                              "
                            >
                              <div
                                class="
                                  d-flex
                                  justify-content-start
                                  align-items-center
                                "
                              >
                                <img
                                  :src="menu.IconUrl"
                                  height="20"
                                  width="20"
                                />
                                <p
                                  v-if="
                                    currentEditMenuId !=
                                    'AppLobbyMenu_' + menu.MenuID
                                  "
                                  class="
                                    d-flex
                                    justify-content-start
                                    align-items-center
                                    text-nowrap
                                  "
                                  @dblclick="
                                    onEditMenuClick(
                                      'AppLobbyMenu_' + menu.MenuID
                                    )
                                  "
                                >
                                  {{ DisplayLanguageLabel(menu) }}
                                </p>
                                <input
                                  v-if="
                                    currentEditMenuId ==
                                    'AppLobbyMenu_' + menu.MenuID
                                  "
                                  type="text"
                                  :id="'Input_AppLobbyMenu_' + menu.MenuID"
                                  v-model="menu[menu.ModelDisplayLabel]"
                                  :placeholder="menu.DisplayLabel"
                                  class="menu-input"
                                  v-on:keydown.enter.prevent="onEnterKeyPress"
                                  @blur="currentEditMenuId = ''"
                                />
                              </div>
                              <div
                                v-show="
                                  currentEditMenuId !=
                                  'AppLobbyMenu_' + menu.MenuID
                                "
                                class="edit-dlt"
                              >
                                <span
                                  @click="
                                    onEditMenuClick(
                                      'AppLobbyMenu_' + menu.MenuID
                                    )
                                  "
                                  ><v-icon color="#959595" size="20px">
                                    mdi-square-edit-outline</v-icon
                                  ></span
                                >
                                <span
                                  @click="onDeleteMenuClick(menu.MenuID, 2, 3)"
                                  ><v-icon color="#959595" size="20px">
                                    mdi-trash-can-outline</v-icon
                                  ></span
                                >
                              </div>
                            </div>
                          </li>
                        </draggable>
                      </ul>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </v-tab-item>
          </v-tabs-items>

          <div class="d-flex mt-8 justify-content-end align-items-center">
            <v-btn
              class="mr-2 cancel-standard"
              outlined
              width="100px"
              color="#1c1d26"
              depressed
              @click="CancelManageMenu"
            >
              Cancel
            </v-btn>
            <!-- :loading="sponsorsSaving" -->
            <v-btn
              class="px-6 save-standard"
              dark
              color="#2376e5"
              @click="SaveManageMenu"
              width="100px"
              :loading="ManageMenuUpdating"
            >
              Save
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <!-- Mobilemenu Modal -->
  </div>
</template>

<style>
.menu-dragbox {
  height: 340px;
  /* overflow-y: auto; */
}
</style>
<script>
// import store from "@/store";
import APIs from "@/components/APIInit";
import axios from "axios";
// import jQuery from "jquery";
// let $ = jQuery;
// import { bus } from "@/main";
// import db from "../components/firebaseInit";
import draggable from "vuedraggable";

var vm;
export default {
  components: {
    draggable,
  },
  props: {
    event_collectionName: {
      type: String,
      default: "",
    },
    clientId: {
      type: String,
      default: "",
    },
    eventId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      radios: null,
      radios2: null,
      items: ["Virtual", "Physical", "In-Person"],
      items2: ["GMT +00:00 UTC", "GMT +00:01 UTC", "GMT +00:02 UTC"],
      items3: ["Unique passcode per attendee", "Common passcode per attendee"],
      items4: ["English", "Chinese", "Japanese", "Hindi", "Russian", "Korean"],
      ex4: ["red"],
      tab: 0,
      ManageMenuUpdating: false,
      ClientMenu: [],
      WebTopMenu: [],
      WebLeftMenu: [],
      AppBottomMenu: [],
      AppHamburgerMenu: [],
      AppLobbyMenu: [],
      currentEditMenuId: "",
      defaultLanguage: "english",
    };
  },
  computed: {},
  watch: {},
  created() {
    vm = this;
  },
  mounted() {
    vm.getDefaultEventLanguage();
    if (vm.clientId && vm.eventId) {
      vm.GetEventMenu();
    }
  },
  methods: {
    getDefaultEventLanguage() {
      let currentEvent = vm.getCurrentEvent();
      if (currentEvent && currentEvent.DefaultLanguage) {
        vm.defaultLanguage = currentEvent.DefaultLanguage.toLowerCase();
      }
    },
    DisplayLanguageLabel(menu) {
      var result = "";
      if (menu) {
        if (vm.defaultLanguage == "chinese" && menu.DisplayLabel_zh) {
          result = menu.DisplayLabel_zh;
          menu.ModelDisplayLabel = "DisplayLabel_zh";
        } else if (vm.defaultLanguage == "english" && menu.DisplayLabel) {
          result = menu.DisplayLabel;
          menu.ModelDisplayLabel = "DisplayLabel";
        } else if (vm.defaultLanguage == "french" && menu.DisplayLabel_fr) {
          result = menu.DisplayLabel_fr;
          menu.ModelDisplayLabel = "DisplayLabel_fr";
        } else if (vm.defaultLanguage == "german" && menu.DisplayLabel_de) {
          result = menu.DisplayLabel_de;
          menu.ModelDisplayLabel = "DisplayLabel_de";
        } else if (menu.DisplayLabel) {
          result = menu.DisplayLabel;
          menu.ModelDisplayLabel = "DisplayLabel";
        }
      }
      return result;
    },
    cloneOriginal(menu) {
      return { ...menu };
    },
    onEnterKeyPress(e) {
      if (e.which == 13) {
        var el = document.getElementById(e.target.id);
        if (el) {
          el.blur();
        }
      }
    },
    onEditMenuClick(menuId) {
      vm.currentEditMenuId = menuId;
      setTimeout(() => {
        var el = document.getElementById("Input_" + menuId);
        if (el) {
          el.select();
          el.setSelectionRange(0, 99999);
        }
      }, 10);
    },
    onDeleteMenuClick(menuId, option1, option2) {
      if (option1 == 1 && option2 == 1) {
        vm.WebTopMenu = vm.WebTopMenu.filter(function (item) {
          return item.MenuID != menuId;
        });
      }
      if (option1 == 1 && option2 == 2) {
        vm.WebLeftMenu = vm.WebLeftMenu.filter(function (item) {
          return item.MenuID != menuId;
        });
      }
      if (option1 == 2 && option2 == 1) {
        vm.AppBottomMenu = vm.AppBottomMenu.filter(function (item) {
          return item.MenuID != menuId;
        });
      }
      if (option1 == 2 && option2 == 2) {
        vm.AppHamburgerMenu = vm.AppHamburgerMenu.filter(function (item) {
          return item.MenuID != menuId;
        });
      }
      if (option1 == 2 && option2 == 3) {
        vm.AppLobbyMenu = vm.AppLobbyMenu.filter(function (item) {
          return item.MenuID != menuId;
        });
      }
    },
    checkMoveSelectedWeb: function (evt) {
      //console.log(evt.draggedContext.element.MenuID)
      //console.log(evt.relatedContext.element.MenuID)
      let MenuID = evt.draggedContext.element.MenuID;
      let found = this.WebTopMenu.some((el) => el.MenuID === MenuID);
      let foundl = this.WebLeftMenu.some((el) => el.MenuID === MenuID);
      if (found || foundl) {
        return false;
      } else {
        // this.WebTopMenu = [...this.WebTopMenu];
        this.WebTopMenu = JSON.parse(JSON.stringify(this.WebTopMenu));
        // this.WebLeftMenu = [...this.WebLeftMenu];
        // this.WebTopMenu = this.WebTopMenu.filter(function () {
        //   return true;
        // });
        // this.WebLeftMenu = this.WebLeftMenu.filter(function () {
        //   return true;
        // });
        // var result = [];
        // vm.WebLeftMenu = vm.WebLeftMenu.map(function (item) {
        //   result.push(clone(item));
        // });
        // vm.WebLeftMenu = result;
        return true;
      }
    },
    checkMoveSelectedApp: function (evt) {
      let MenuID = evt.draggedContext.element.MenuID;
      if (evt.to.id == "AppBottomMenu") {
        let found = this.AppBottomMenu.some((el) => el.MenuID === MenuID);
        if (found) {
          return false;
        }
      }

      if (evt.to.id == "AppHamburgerMenu") {
        let found = this.AppHamburgerMenu.some((el) => el.MenuID === MenuID);
        if (found) {
          return false;
        }
      }
      if (evt.to.id == "AppLobbyMenu") {
        let found = this.AppLobbyMenu.some((el) => el.MenuID === MenuID);
        if (found) {
          return false;
        }
      }
      //if (found || foundl) return false;
      return true;
    },
    checkAppLength(field) {
      if (field == "bottom") {
        return !(this.AppBottomMenu.length >= 4);
      } else {
        return true;
      }
    },
    GetEventMenu() {
      vm.ClientMenu = [];
      vm.WebTopMenu = [];
      vm.WebLeftMenu = [];
      vm.AppBottomMenu = [];
      vm.AppHamburgerMenu = [];
      vm.AppLobbyMenu = [];

      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
      };
      axios
        .post(APIs.GetEventMenu, requestData, {
          headers: headers,
        })
        .then((response) => {
          if (response && response.data && response.data.status == 200) {
            if (response.data.data) {
              debugger;
              let responseData = response.data.data;
              if (responseData.ClientMenu) {
                //vm.ClientMenu = responseData.ClientMenu;
                var webinerMenuIDs = [1001, 1005, 1030]; //1002 - Sessions
                vm.ClientMenu = responseData.ClientMenu.filter(function (item) {
                  return webinerMenuIDs.includes(item.MenuID);
                });
              }
              if (
                responseData.EventWebMenu &&
                responseData.EventWebMenu.TopMenu
              ) {
                vm.WebTopMenu = responseData.EventWebMenu.TopMenu;
                //vm.SetMenuDisplayLabelModel(vm.WebTopMenu);
              }
              if (
                responseData.EventWebMenu &&
                responseData.EventWebMenu.LeftMenu
              ) {
                vm.WebLeftMenu = responseData.EventWebMenu.LeftMenu;
                //vm.SetMenuDisplayLabelModel(vm.WebLeftMenu);
              }
              if (
                responseData.EventAppMenu &&
                responseData.EventAppMenu.BottomMenu
              ) {
                vm.AppBottomMenu = responseData.EventAppMenu.BottomMenu;
                //vm.SetMenuDisplayLabelModel(vm.AppBottomMenu);
              }
              if (
                responseData.EventAppMenu &&
                responseData.EventAppMenu.HamburgerMenu
              ) {
                vm.AppHamburgerMenu = responseData.EventAppMenu.HamburgerMenu;
                //vm.SetMenuDisplayLabelModel(vm.AppHamburgerMenu);
              }
              if (
                responseData.EventAppMenu &&
                responseData.EventAppMenu.LobbyMenu
              ) {
                vm.AppLobbyMenu = responseData.EventAppMenu.LobbyMenu;
                //vm.SetMenuDisplayLabelModel(vm.AppLobbyMenu);
              }
            }
          }
        })
        .catch((error) => {
          console.log("GetEventMenu: " + error);
        });
    },
    SetMenuDisplayLabelModel(menuList) {
      for (var i = 0; i < menuList.length; i++) {
        if (vm.defaultLanguage == "chinese" && menuList[i].DisplayLabel_zh) {
          menuList[i].ModelDisplayLabel = "DisplayLabel_zh";
        } else if (
          vm.defaultLanguage == "english" &&
          menuList[i].DisplayLabel
        ) {
          menuList[i].ModelDisplayLabel = "DisplayLabel";
        } else if (
          vm.defaultLanguage == "french" &&
          menuList[i].DisplayLabel_fr
        ) {
          menuList[i].ModelDisplayLabel = "DisplayLabel_fr";
        } else if (
          vm.defaultLanguage == "german" &&
          menuList[i].DisplayLabel_de
        ) {
          menuList[i].ModelDisplayLabel = "DisplayLabel_de";
        } else if (menuList[i].DisplayLabel) {
          menuList[i].ModelDisplayLabel = "DisplayLabel";
        }
      }
      return menuList;
    },
    SaveManageMenu() {
      vm.ManageMenuUpdating = true;
      let headers = {
        "content-type": "application/json",
        Authorization: "Bearer " + vm.getSessionToken(),
      };
      let requestData = {
        key: {
          instanceId: "OA_UAT",
          clientId: vm.clientId,
          eventId: vm.eventId,
        },
      };

      var index = 0;
      if (vm.tab == 0) {
        index = 0;
        vm.WebTopMenu.map(function (item) {
          item.DisplayOrder = index++;
          delete item.ModelDisplayLabel;
        });
        index = 0;
        vm.WebLeftMenu.map(function (item) {
          item.DisplayOrder = index++;
          delete item.ModelDisplayLabel;
        });
        requestData.data = {
          webMenu: {
            topMenu: vm.WebTopMenu,
            leftMenu: vm.WebLeftMenu,
          },
        };
      } else if (vm.tab == 1) {
        index = 0;
        vm.AppBottomMenu.map(function (item) {
          item.DisplayOrder = index++;
          delete item.ModelDisplayLabel;
        });
        index = 0;
        vm.AppHamburgerMenu.map(function (item) {
          item.DisplayOrder = index++;
          delete item.ModelDisplayLabel;
        });
        index = 0;
        vm.AppLobbyMenu.map(function (item) {
          item.DisplayOrder = index++;
          delete item.ModelDisplayLabel;
        });
        requestData.data = {
          appMenu: {
            bottomMenu: vm.AppBottomMenu,
            hamburgerMenu: vm.AppHamburgerMenu,
            lobbyMenu: vm.AppLobbyMenu,
          },
        };
      }

      axios
        .post(APIs.UpdateEventMenu, requestData, {
          headers: headers,
        })
        .then((response) => {
          vm.ManageMenuUpdating = false;
          debugger;
          //alert("SaveManageMenu Success");
          //console.log(response);
          if (response && response.data && response.data.status == 200) {
            vm.showSnackbar("Menu updated successfully ", "success", "top");
            vm.$emit("OnUpdateManageMenuSuccess");
          } else {
            vm.showSnackbar("Menu updated failed!", "error", "top");
          }
        })
        .catch((error) => {
          vm.ManageMenuUpdating = false;
          debugger;
          //alert("SaveManageMenu Failure");
          console.log("SaveManageMenu: " + error);
          vm.showSnackbar("Menu updated failed!", "error", "top");
        });
    },
    CancelManageMenu() {
      vm.$emit("OnCancelManageMenuSuccess");
    },
  },
};
</script>
